import WhyQmee from 'components/pages/WhyQmee/WhyQmee';
import { buildPage, buildStaticProps } from 'utils/pageHelper';

export const getServerSideProps = buildStaticProps('why-qmee');
export default buildPage(WhyQmee, {
  skipSSR: true,
  requiresAuthentication: false,
  metaData: {
    title: 'Why Qmee',
    description: 'Why Qmee',
  },
});
